import {
    HttpResponse,
    TenantIpRestrictionModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel,
} from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';

export class TenantIpRestrictionsDataService implements CrudService<TenantIpRestrictionModel, TenantIpRestrictionModel> {
    getAll(query: CrudDataQuery<TenantIpRestrictionModel>): Promise<CrudEnumerableResponse<TenantIpRestrictionModel>> {
        return ApiService.api.getTenantIpRestrictionBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<TenantIpRestrictionModel>): Promise<CrudEnumerableResponse<TenantIpRestrictionModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TenantIpRestrictionModel>> {
        return ApiService.api.getTenantIpRestrictionById(id, params);
    }

    create(item: TenantIpRestrictionModel, params?: RequestParams): Promise<CrudResponse<TenantIpRestrictionModel>> {
        return ApiService.api.insertTenantIpRestriction(item, params);
    }

    update(item: TenantIpRestrictionModel, params?: RequestParams): Promise<TenantIpRestrictionModel> {
        return ApiService.api
            .updateTenantIpRestriction(item.id as Required<string>, item, params)
            .then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TenantIpRestrictionModel> {
        return ApiService.api.patchTenantIpRestriction(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<TenantIpRestrictionModel>): Promise<CrudEnumerableResponse<TenantIpRestrictionModel>> {
        return ApiService.api.deleteTenantIpRestrictions(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationTenantIpRestriction(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<TenantIpRestrictionModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: TenantIpRestrictionModel, params?: RequestParams): Promise<CrudResponse<TenantIpRestrictionModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getTenantIpRestrictionGroupped(query, params);
    }
}
